<template>
  <div class="shop-list">
    <!--导航-->
    <div class="dk-nav">
      <nav-bar title="附近门店" url="/home" />
    </div>

    <!--门店列表-->
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
    <div>
      <template v-if="loading">
      <template v-if="shop.data">
        <div class="van-cell-group van-hairline--top-bottom van-panel" style="margin-bottom: 6px; font-size: 12px;" v-for="(item,index) in sortBykey(filterBy(shop.data,city),'coordinate')">
          <div class="van-cell van-panel__header dk-header-after">
            <div class="van-cell__title"  @click="goUrl('/shop/detail/'+item.id)">
              <span style="float: left;">{{item.title}}</span>
              <span style="float: right;">{{item.coordinate}}</span>
              <div class="van-cell__label" style="clear: both;">{{item.address}}</div>
            </div>
          </div>
          <div class="van-panel__content"></div>
          <div class="van-panel__footer van-hairline--top dk-footer-after">
            <button class="van-button van-button--info van-button--small" @click="getTel(item.phone)">
              <div class="van-button__content">
                <span class="van-button__text">电话:{{item.phone}}</span>
              </div>
            </button>
            <button class="van-button van-button--info van-button--small" style="margin-left: 10px;"  @click="goUrl('/shop/detail/'+item.id)">
              <div class="van-button__content">
                <span class="van-button__text">电子地图</span>
              </div>
            </button>
            <button class="van-button van-button--info van-button--small" style="margin-left: 10px;" @click="goUrl('/shop/qr/'+item.id)">
              <div class="van-button__content">
                <span class="van-button__text">二维码</span>
              </div>
            </button>
          </div>
        </div>
      </template>
      </template>
      <template v-else>
        <van-loading type="spinner" color="#ff8917" vertical />
      </template>
    </div>
    </van-pull-refresh>

  </div>
</template>

<script>
import {mapState,mapActions} from 'vuex'
import NavBar from '../../components/NavBar.vue'
export default {
    'name': 'ShopList',
    data() {
        return {
          isLoading: false,
          loading: false
        };
    },
    computed: {
        ...mapState({
            city: state => state.cityData.city,
            shop: state => state.shop.shop_list,
            lng: state => state.cityData.lng,
            lat: state => state.cityData.lat
        })
    },
    methods: {
        ...mapActions(['requestShop']),
        goUrl(val) {
            return this.$router.push({path: val})
        },
        getTel(val) {
           return window.location.href = 'tel:'+val
        },
        filterBy(list,value){
            return list.filter(function(lists){
                if(value == "重庆") {
                  return lists.city.match('市辖区');
                }else{
                  return lists.city.match(value);
                }
            })
        },
        onRefresh() {
          setTimeout(() => {
            this.isLoading = false;
          }, 1000);
        },
        sortBykey(ary, key) {
          return ary.sort(function (a, b) {
            let x = a[key].substring(0,a[key].indexOf("."))
            let y = b[key].substring(0,b[key].indexOf("."))
           // return ((x > y) ? -1 : (x < y) ? 1 : 0)
            return x-y
          })
        }
    },
    components: {
      NavBar
    },
    mounted() {
        this.requestShop({"thit":this,"lnglat":this.lng+","+this.lat,"city":this.city});
    }
};
</script>

<style scoped>
.home >>> .van-grid-item__icon {
  font-size: 1.3rem;
}

/*导航*/
.dk-nav {
  width: 100%;
  height: 52px;
}
.shop-list >>> .van-nav-bar {
  z-index: 9;
  background-color: #ff8917;
  padding-top: 6px;
}
.shop-list >>> .van-nav-bar__text {
  color: #fff;
}
.shop-list >>> .van-nav-bar__title {
  color: #fff;
}
.shop-list >>> .van-card__thumb img {
  border-radius: 0.1rem;
}
.shop-list >>> .van-nav-bar .van-icon {
  color: #fff;
}
/* 取消伪类 */
.dk-header-after::after {
  border-bottom:none;
}
.dk-footer-after::after {
  border-top:none;
}

.shop-list >>> .van-button--info {
    color: #fff;
    background-color: #ff8917;
    border: 0.02667rem solid #ff8917;
}
</style>
